"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcExchangeRateBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_exchange_rate_constants_1 = require("./bc-exchange-rate-constants");
var common_constants_1 = require("./../../../common/constants/common-constants");
var BcExchangeRateBehavior = (function (_super) {
    __extends(BcExchangeRateBehavior, _super);
    function BcExchangeRateBehavior() {
        var _this = _super.call(this) || this;
        _this.BcExchangeRateDollarValueRate = '';
        _this.BcExchangeRateDollarFinal = '';
        _this.BcExchangeRateValue = '';
        _this.BcExchangeRateCoinTo = '';
        _this.BcExchangeSymbolCoin = '$';
        _this.BcExchangeRateTooltip = '';
        return _this;
    }
    BcExchangeRateBehavior.setUpAll = function () {
        var BcExchangeRateElements = Array.from(document.querySelectorAll(".".concat(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_RATE)));
        var elements = [];
        for (var _i = 0, BcExchangeRateElements_1 = BcExchangeRateElements; _i < BcExchangeRateElements_1.length; _i++) {
            var element = BcExchangeRateElements_1[_i];
            var bcExchangeRateBehavior = new BcExchangeRateBehavior();
            bcExchangeRateBehavior.setElement(element);
            bcExchangeRateBehavior.setUp();
            elements.push(bcExchangeRateBehavior);
        }
        return elements;
    };
    BcExchangeRateBehavior.prototype._setUp = function () {
        this.BcExchangeRateDollarValueRate = this.mySelf.getAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.DOLLAR_ATR);
        this.BcExchangeRateValue = this.mySelf.getAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.VALUE_TO_ATR);
        this.BcExchangeRateCoinTo = this.mySelf.getAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.COIN_ATR);
        this.BcExchangeRateTooltip = this.mySelf.getAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.TOOLTIP_ATR);
        this.BcExchangeSymbolCoin = this.mySelf.getAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.SYMBOL_ATR);
        this.setAccessibility(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_TOOLTIP);
        this.setupTooltip();
        this.changeValuesInView(parseFloat(this.BcExchangeRateDollarValueRate), parseFloat(this.BcExchangeRateValue), this.BcExchangeRateCoinTo);
    };
    BcExchangeRateBehavior.prototype.exchangeValue = function (valueRate, ammount) {
        var final = (valueRate * ammount).toFixed(common_constants_1.COMMON_CONSTANTS_NUMBERS.N2);
        final = this.numberAnatomy(final);
        return final;
    };
    BcExchangeRateBehavior.prototype.numberAnatomy = function (value) {
        var formated = parseFloat((value)).toLocaleString('es', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return formated;
    };
    BcExchangeRateBehavior.prototype.decimalLessSize = function (element, value) {
        var partes = value.split(',');
        element.innerHTML = "".concat(this.BcExchangeSymbolCoin, " ").concat(partes[0]);
        if (partes[1]) {
            var decimal = document.createElement(bc_exchange_rate_constants_1.BcExchangeRateConstants.SPAN_TAG);
            decimal.classList.add(bc_exchange_rate_constants_1.BcExchangeRateConstants.DECIMAL);
            decimal.textContent = ",".concat(partes[1]);
            element.appendChild(decimal);
        }
    };
    BcExchangeRateBehavior.prototype.addElementDecimal = function (element, value, coinName) {
        var partes = value.split(',');
        element.innerHTML = "$".concat(bc_exchange_rate_constants_1.BcExchangeRateConstants.NUMBER_1, " ").concat(bc_exchange_rate_constants_1.BcExchangeRateConstants.USD_CLASS, " = $ ").concat(partes[0]);
        if (partes[1]) {
            var decimal = document.createElement(bc_exchange_rate_constants_1.BcExchangeRateConstants.SPAN_TAG);
            decimal.classList.add(bc_exchange_rate_constants_1.BcExchangeRateConstants.DECIMAL_BOLD);
            decimal.textContent = ",".concat(partes[1]);
            element.appendChild(decimal);
            var coin = document.createElement(bc_exchange_rate_constants_1.BcExchangeRateConstants.SPAN_TAG);
            coin.classList.add(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_DOLLAR);
            coin.textContent = " ".concat(coinName);
            element.appendChild(coin);
        }
    };
    BcExchangeRateBehavior.prototype.changeValuesInView = function (valueRate, ammount, coinToName) {
        this.BcExchangeRateDollarFinal = this.exchangeValue(valueRate, ammount);
        if (this.BcExchangeRateDollarFinal === 'NaN') {
            return;
        }
        this.addElementDecimal(this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_DOLLAR), this.numberAnatomy(valueRate.toString()), coinToName);
        this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_NAME).innerHTML = coinToName;
        this.decimalLessSize(this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_VALUE), this.numberAnatomy(ammount.toString()));
        this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_NAME).innerHTML = "".concat(bc_exchange_rate_constants_1.BcExchangeRateConstants.USD_CLASS);
        this.decimalLessSize(this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_VALUE), this.BcExchangeRateDollarFinal);
    };
    BcExchangeRateBehavior.prototype.setPreLoader = function (show) {
        if (show) {
            var preloader = document.createElement('div');
            preloader.classList.add(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_PRELOADER, bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_PRELOADER_LINE, 'bc-mb-2');
            preloader.setAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.STYLE, "--".concat(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_PRELOADER, "-height: 16px"));
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_DOLLAR).innerHTML = '';
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_NAME).innerHTML = '';
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_VALUE).innerHTML = "";
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_VALUE).innerHTML = "";
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_NAME).innerHTML = "";
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_DOLLAR).appendChild(preloader.cloneNode(true));
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_NAME).appendChild(preloader.cloneNode(true));
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_NAME).appendChild(preloader.cloneNode(true));
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_DOLLAR_VALUE).appendChild(preloader.cloneNode(true));
            this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_COIN_VALUE).appendChild(preloader.cloneNode(true));
        }
        else {
            this.changeValuesInView(parseFloat(this.BcExchangeRateDollarValueRate), parseFloat(this.BcExchangeRateValue), this.BcExchangeRateCoinTo);
        }
    };
    BcExchangeRateBehavior.prototype.setAccessibility = function (label) {
        var content = this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_CONTENT);
        content.setAttribute(bc_exchange_rate_constants_1.BcExchangeRateConstants.ARIA_LABEL, label);
    };
    BcExchangeRateBehavior.prototype.setupTooltip = function () {
        var tooltipText = this.mySelf.getAttribute('tooltip');
        var tooltipTitle = this.mySelf.getAttribute('tooltiptitle');
        var tooltipBody = this.mySelf.querySelector(bc_exchange_rate_constants_1.BcExchangeRateConstants.BC_EXCHANGE_TOOLTIP);
        if (tooltipText) {
            this.setupTooltipAttributes(tooltipBody, tooltipText, tooltipTitle);
        }
    };
    BcExchangeRateBehavior.prototype.setupTooltipAttributes = function (element, tooltipText, tooltipTitle) {
        element.setAttribute('bctooltipposition', 'top');
        element.setAttribute('bctooltiptext', tooltipText);
        element.setAttribute('bctooltiptitle', tooltipTitle);
        element.classList.add('bc-tooltip');
    };
    return BcExchangeRateBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcExchangeRateBehavior = BcExchangeRateBehavior;
